module.exports = __webpack_public_path__ + "static/media/server_error.562e8e90.png";